import { RegistrationSession, Session } from '@/api/dtos';

export const createPackageSessionRegistrations = (
    packageSessions?: Session[]
): RegistrationSession[] => {
    return (
        packageSessions
            ?.filter((session) => !session.required)
            .map((session) => new RegistrationSession({ sessionId: session.id })) ?? []
    );
};
